import { TabType } from '@heidi/session/contracts';

import type { ToolUseItem } from '../../../contracts';
import { readToolResultText } from '../../../contracts';
import type { Artifact } from '../../../data/projects/artifacts/state';
import type { ArtifactRefPorts } from '../../../data/projects/timeline/presentation/tool-artifact-refs';
import { artifactFromToolUse as artifactFromToolUseWithPorts } from '../../../data/projects/timeline/presentation/tool-registry';
import { getWorkHostPort } from '../../work-home/work-home-ports';

const SESSION_TAB_VALUES = new Set<string>(Object.values(TabType));
const ARTIFACT_REF_PORTS: ArtifactRefPorts = {
  isSlideBuilderEnabled: () => getWorkHostPort('shell').isSlideBuilderEnabled(),
  sessionTabs: { context: TabType.CONTEXT, document: TabType.DOCUMENT },
  parseSessionTab: (value) =>
    SESSION_TAB_VALUES.has(value) ? (value as TabType) : undefined,
};

export const toolResultText = readToolResultText;
export const artifactFromToolUse = (item: ToolUseItem): Artifact | undefined =>
  artifactFromToolUseWithPorts(item, ARTIFACT_REF_PORTS);
